import React from 'react';

const DragHandleIcon: React.FC = () => (
  <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 2, opacity: 0.55 }}>
    {[0, 1, 2].map((i) => (
      <span key={i} style={{ display: 'flex', gap: 2 }}>
        {[0, 1].map((j) => (
          <span
            key={j}
            style={{ width: 3, height: 3, borderRadius: '50%', background: 'currentColor', display: 'block' }}
          />
        ))}
      </span>
    ))}
  </span>
);

export default DragHandleIcon;
